import React, {useEffect} from 'react';
import WrapPageElement from './src/components/general/WrapPageElement/WrapPageElement';

const myWrapPageElement = ({element, props}) => {
  return <WrapPageElement {...props}>{element}</WrapPageElement>;
};

export default myWrapPageElement;
